import { render, staticRenderFns } from "./RefreshJudgmentButton.vue?vue&type=template&id=7a7c7071"
import script from "./RefreshJudgmentButton.vue?vue&type=script&lang=js"
export * from "./RefreshJudgmentButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports